import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const ResumedSequencePlay = () => (
  <ImageIcon src={Images.ResumedSequencePlay} alt="Resumed Sequence Play" />
);

export default ResumedSequencePlay;
